export { default } from './DisneyCosmicToy';
